module.exports = __webpack_public_path__ + "assets/443ab413c03d5d19ac3a1c236633c42d.png";